import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { cardAnatomy as parts } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  container: {
    borderRadius: 'var(--chakra-radii-2xl)',
    boxShadow: '0px 5px 14px rgba(0, 0, 0, 0.05)',
    paddingTop: 'var(--chakra-space-1)',
  },
});

const cardTheme = defineMultiStyleConfig({ baseStyle });

export default cardTheme;
